module.exports = __webpack_public_path__ + "static/media/logo (2).e58e21ac.png";